var _path, _path2, _path3, _path4, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFrame(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 643,
    height: 560,
    viewBox: "0 0 643 560",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M605.028 26.7325L36.1874 33.0285L50.0195 534.629L618.86 528.333L605.028 26.7325ZM31.0278 28.6426L45.1049 539.126L624.02 532.719L609.943 22.235L31.0278 28.6426Z",
    fill: "url(#calls-frame-paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M592.958 1.49364L17.4008 7.86402L31.3451 513.531L606.902 507.161L592.958 1.49364ZM15.6811 6.40745L29.7067 515.025L608.622 508.617L594.596 -9.15527e-05L15.6811 6.40745Z",
    fill: "url(#calls-frame-paint1_linear)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M626.344 36.5985L52.2519 42.9527L66.1962 548.62L640.288 542.266L626.344 36.5985ZM50.5365 41.4961L64.5621 550.114L642.004 543.722L627.978 35.1048L50.5365 41.4961Z",
    fill: "url(#calls-frame-paint2_linear)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M576.519 46.485L2.42638 52.8392L16.3707 558.506L590.463 552.152L576.519 46.485ZM0.710938 51.3825L14.7366 560L592.178 553.609L578.153 44.9913L0.710938 51.3825Z",
    fill: "url(#calls-frame-paint3_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "calls-frame-paint0_linear",
    x1: 7.76414,
    y1: 305.714,
    x2: 584.9,
    y2: 289.799,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A86B1D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1116,
    stopColor: "#C49642"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2229,
    stopColor: "#DAB960"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3275,
    stopColor: "#EBD275"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4228,
    stopColor: "#F5E182"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#F8E687"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6151,
    stopColor: "#F6E181"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7707,
    stopColor: "#F1D370"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9485,
    stopColor: "#E9BD54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6B54A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "calls-frame-paint1_linear",
    x1: 7.76414,
    y1: 305.714,
    x2: 584.9,
    y2: 289.799,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A86B1D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1116,
    stopColor: "#C49642"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2229,
    stopColor: "#DAB960"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3275,
    stopColor: "#EBD275"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4228,
    stopColor: "#F5E182"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#F8E687"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6151,
    stopColor: "#F6E181"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7707,
    stopColor: "#F1D370"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9485,
    stopColor: "#E9BD54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6B54A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "calls-frame-paint2_linear",
    x1: 7.76414,
    y1: 305.714,
    x2: 584.9,
    y2: 289.799,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A86B1D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1116,
    stopColor: "#C49642"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2229,
    stopColor: "#DAB960"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3275,
    stopColor: "#EBD275"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4228,
    stopColor: "#F5E182"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#F8E687"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6151,
    stopColor: "#F6E181"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7707,
    stopColor: "#F1D370"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9485,
    stopColor: "#E9BD54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6B54A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "calls-frame-paint3_linear",
    x1: 7.76414,
    y1: 305.714,
    x2: 584.9,
    y2: 289.799,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A86B1D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1116,
    stopColor: "#C49642"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2229,
    stopColor: "#DAB960"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3275,
    stopColor: "#EBD275"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4228,
    stopColor: "#F5E182"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#F8E687"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6151,
    stopColor: "#F6E181"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7707,
    stopColor: "#F1D370"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9485,
    stopColor: "#E9BD54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6B54A"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame);
export default __webpack_public_path__ + "static/media/frame.deab0305.svg";
export { ForwardRef as ReactComponent };